/**
 * @file 合計金額計算
 */
'use strict';

/**
 * @classname PriceCalculateView
 * @classdesc 合計金額計算
 */
export default class PriceCalculateView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - コントローラー
	 */
	constructor($e, controller) {
		console.log('PriceCalculateView.constructor');
		this._$e = $e;
		this._controller = controller;
		this.calculate();
		controller.on('calculate', () => {this.calculate();});
	};


	/**
	 * 合計金額を計算する
	 *
	 * @memberof PriceCalculateView
	 * @return {undefined}
	 */
	calculate() {
		console.log('PriceCalculateView.calculate');
		let price = 0;
		$('.list-item[data-price][data-quantity]').each(function (idx, e) {
			const $e = $(e);
			const p = parseInt($e.attr('data-price'));
			const q = parseInt($e.attr('data-quantity'));
			const t = p * q;
			price = price + t;
		});
		this._$e.text(`¥${price.toLocaleString()}`);
	};
}
